<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import DefaultSelect from '../../../selects/default-select'
import { type ComputedColumnInterface } from '../../DefaultTableInterfaces'
import { EnumSelectTableFilter } from '../../filters/Filters'
import { type DefaultSelectHeaderInterface } from '../HeadersTableInterfaces'
import HeaderSort from './DefaultTableHeaderSort.vue'

export default defineComponent({
  props: {
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    enableSorting: {
      type: Boolean,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
    },
    onSort: {
      type: Function as PropType<() => void>,
    },
  },
  setup(props) {
    const filter: EnumSelectTableFilter = props.column.filter as unknown as EnumSelectTableFilter
    const header: DefaultSelectHeaderInterface = props.column.header as unknown as DefaultSelectHeaderInterface

    const setValue = (val: { id: string, name: string } | undefined) => {
      filter.addValue(val)
    }

    return () => (

      <div class="ark-ui-table-default-select-header default-table-header">
        <DefaultSelect
          items={header.options}
          placeholder={props.column.name}
          modelValue={filter.value}
          onValueChange={setValue}
          showItemsCount={5}
        />

        { props.enableSorting && props.onSort && (
          <HeaderSort column={props.column} onSort={props.onSort} sortField={props.sortField} sortOrder={props.sortOrder}/>
        ) }
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-default-select-header {
  position: relative;
  align-items: center;
  box-sizing: border-box;

  height: 48px;
  display: flex;
  justify-content: space-between;

  .ark-ui-select-head {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }

  > *:first-child {
    width: 100%;
    min-width: 95px;
  }

  &.active,
  &:hover {
    & path {
      fill: #585B69;
    }
  }
}
</style>
